export const AuthenticatedPath = {
  HOME: '/home',
  AGENT: '/admin/agent',
  CAMPAIGN: '/admin/campaign',
  ASSISTANTS: '/admin/assistants',
  CREATE_AGENT: '/admin/agent/new',
  CREATE_CAMPAIGN: '/admin/campaign/new',
  EDIT_AGENT: '/admin/agent/edit',
  EDIT_CAMPAIGN: '/admin/campaign/edit',
  EDIT_CAMPAIGN_V2: '/admin/campaign/:campaignId/edit',
  CALL_DETAIL: '/admin/campaign/:campaignId/call/:callId',
  CONVERSATION_DOWNLOAD: '/conversation/:id/download',
  RECORDING: '/calls/:id/recording',
} as const;

export const UnauthenticatedPath = {
  SIGN_IN: '/sign-in',
  SSO: '/sso',
  FORGOT: '/forgot-password',
  VERIFY: '/verify-code',
  RESET: '/reset-password',
} as const;

export const AuthPath = {
  NOT_FOUND: `/auth/404`,
  SIGN_IN: '/auth/sign-in',
} as const;

export const SuperAdminAuthenticatedPath = {
  HOME_PAGE: '/super-admin/home',
  COMPANIES: '/super-admin/companies',
  AMBIENCE_SOUNDS: '/super-admin/ambience-sounds',
  EDIT_COMPANY: '/super-admin/company/edit',
  MONITOR_CONVERSATION: '/super-admin/conversation/monitor',
  MONITOR_TOKENS: '/super-admin/tokens-monitoring',
  MANAGE_VOICE_SETTINGS: '/super-admin/voice-settings',
  MANAGE_TRANSCRIBER: '/super-admin/transcriber/management',
  UNIT_WEIGHTS: '/super-admin/unit-weights',
} as const;

export const SuperAdminUnauthenticatedPath = {
  SIGN_IN: '/super-admin/sign-in',
} as const;

export const SuperAdminAuthPath = {
  NOT_FOUND: `/admin/auth/404`,
  SIGN_IN: '/admin/sign-in',
} as const;
